<template>
  <div>
    <div>
      <div>
        <!-- /End replace -->
      </div>
      <div class="container">
        <h2>Dashboard</h2>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      name: "",
    };
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState({
      user: "user",
    }),
  },
  methods: {
    logout() {
      axios.post("/logout").then((response) => {
        localStorage.removeItem("isLoggedIn");
        this.$router.push({ name: "Home" });
      });
    },
  },
};
</script>
